export const FONT_MAP: Record<string, string> = {
  // Klucz: font-family z index.css | Wartość: nazwa pliku z terminala
  "Caveatbrush": "/fonts/caveatbrush-regular.ttf",
  "Margarine-Regular": "/fonts/Margarine-Regular.ttf",
  "SpicyRice": "/fonts/SpicyRice-Regular.ttf",
  "AmaticSC": "/fonts/AmaticSC-Regular.ttf",
  "AbhayaLibre-Regular": "/fonts/AbhayaLibre-Regular.ttf",
  "AmaticSCBold": "/fonts/AmaticSC-Bold.ttf",
  "DemoConeriaScript": "/fonts/Demo_ConeriaScript.ttf",
  "BarlowThin": "/fonts/Barlow-Thin.ttf",
  "BarlowMedium": "/fonts/Barlow-Medium.ttf",
  "BarlowLight": "/fonts/Barlow-Light.ttf",
  "AveUtan": "/fonts/AveUtan.ttf",
  "GreatVibes": "/fonts/GreatVibes-Regular.ttf",
  "BebasNeue": "/fonts/BebasNeue-Regular.otf", 
  "ComicSans": "/fonts/ComicSansMS3.ttf",
  "MonotypeCorsiva": "/fonts/MonotypeCorsiva.ttf",
  "JustSayin": "/fonts/JustSayin.ttf",
  "MaritimeTropicalNeue": "/fonts/Maritime_Tropical_Neue.ttf",
  "OliviaRegular": "/fonts/Olivia-Regular.ttf",
  "iloveglitter": "/fonts/i-love-glitter.regular.otf",
  "Calistoga": "/fonts/Calistoga-Regular.ttf",
  "CenturyGothic": "/fonts/CenturyGothic.ttf",
  "BookAntiquaItalic": "/fonts/BookAntiquaItalic.ttf",
  "kissmeornot": "/fonts/KissMeOrNot.otf",
  "ItaliannoRegular": "/fonts/Italianno-Regular.ttf",
  "Bira": "/fonts/BiraPersonalUseOnly-PPRx.ttf",
  "Happy-Dance": "/fonts/Happy-Dance.ttf",
  "Beryliumrg": "/fonts/beryliumrg.ttf",
  "PatrickHand-Regular": "/fonts/PatrickHand-Regular.ttf",
  "PLZurichCalligraphic": "/fonts/PLZurichCalligraphic.ttf",
  "PLZurich": "/fonts/PLZurich.ttf",
  "PLZurichItalic": "/fonts/ZurichCalligraphicItalic.woff",
  "StylishCalligraphy": "/fonts/StylishCalligraphyDemo-XPZZ.ttf",
  "ClickerScript-Regular": "/fonts/ClickerScript-Regular.ttf",
  "Bellota-Regular": "/fonts/Bellota-Regular.ttf",
  "AlegreyaSC-Italic": "/fonts/AlegreyaSC-Italic.ttf",
  "Cardo-Italic": "/fonts/Cardo-Italic.ttf",
  "Cardo-Regular": "/fonts/Cardo-Regular.ttf",
  "berkshireswash-regular": "/fonts/berkshireswash-regular.ttf",
  "AlegreyaSC-Bold": "/fonts/AlegreyaSC-Bold.ttf",
  "ChopinScript": "/fonts/ChopinScript.otf",
  "HandycheeraRegular": "/fonts/HandycheeraRegular.otf",
  "ArimaMadurai-Regular": "/fonts/ArimaMadurai-Regular.ttf",
  "AphroditeSlimPro": "/fonts/AphroditeSlimPro.otf",
  "Allura-Regular": "/fonts/Allura-Regular.ttf",
  "EBGaramond-Italic": "/fonts/EBGaramond-Italic-VariableFont_wght.ttf",
  "DancingScript-Regular": "/fonts/DancingScript-Regular.ttf",
  "TaggerRegular": "/fonts/Tagger-Regular.otf",
  "CookieRegular": "/fonts/Cookie-Regular.ttf",
  "Nickainley-Normal": "/fonts/Nickainley-Normal.otf",
  "insigne": "/fonts/insigne.otf",
  "Kurale-Regular": "/fonts/Kurale-Regular.ttf",
  "Atma-Regular": "/fonts/Atma-Regular.ttf",
  "Autumninovember": "/fonts/AutumninNovember.ttf",
  "AbrilFatface-Regular": "/fonts/AbrilFatface-Regular.ttf",
  "adlery-pro": "/fonts/adlery-pro.regular.ttf",
  "BaskervilleBoldItalic": "/fonts/BaskervilleWGL4BTBoldItalic.ttf",
  "Gabriola": "/fonts/Gabriola.ttf",
  "Barrio-Regular": "/fonts/Barrio-Regular.otf",
  "odstemplik": "/fonts/odstemplik.ttf",
  "Maitree-Regular": "/fonts/Maitree-Regular.ttf",
  // KD68200WHITE_dzieci_250x353
  "AlegreyaSC-Regular": "/fonts/AlegreyaSC-Regular.ttf",
  "Subcultures": "/fonts/Subcultures.ttf",
  "VeryBerryPro": "/fonts/VeryBerryPro-Regular.ttf",
  "Lato-Regular": "/fonts/Lato-Regular.ttf",
  "BoldStylishCalligraphy": "/fonts/BoldStylishCalligraphy.ttf",
  "SpinweradBold": "/fonts/SpinweradBold.ttf",
  "DancingScript-Medium": "/fonts/DancingScript-Medium.ttf",
  "DancingScript-SemiBold": "/fonts/DancingScript-SemiBold.ttf",
  "Notera": "/fonts/Notera_PersonalUseOnly.ttf",
  // KD57200_WHITE_dzieci_223x250
  "TrajanPro-Bold": "/fonts/TrajanPro-Bold.otf",
  "TrajanPro-Regular": "/fonts/TrajanPro-Regular.ttf",
  "BookAntiqua-Bold": "/fonts/BookAntiqua-Bold.ttf",
  "Cinzel-Regular": "/fonts/Cinzel-Regular.ttf",
  // KD46200WHITE-BABY-215x223mm
  "Aleo-Bold": "/fonts/Aleo-Bold.otf",
  "ArialMT": "/fonts/Arial.ttf",
  "Arial-BoldMT": "/fonts/ARIALBD.TTF",
  "Arimo-Regular": "/fonts/Arimo-Regular.ttf",
  "Batang": "/fonts/Batang-Latin.ttf",
  "BodoniMTCondensed-BoldItalic": "/fonts/BodoniMTCondensed-BoldItalic.ttf",
  "CenturyGothic-Bold": "/fonts/CenturyGothic-Bold.ttf",
  "DJBStraightUpNowBounce": "/fonts/DJBStraightUpNowBounce.ttf",
  "Drogowskaz": "/fonts/Drogowskaz.ttf",
  "Garamond": "/fonts/Garamond.ttf",
  "IndieFlower": "/fonts/IndieFlower.ttf",
  "Itim-Regular": "/fonts/Itim-Regular.ttf",
  "Kalam-Regular": "/fonts/Kalam-Regular.ttf",
  "Lobster-Regular": "/fonts/Lobster-Regular.ttf",
  "Parisienne-Regular": "/fonts/Parisienne-Regular.ttf",
  "Ribeye-Regular": "/fonts/Ribeye-Regular.ttf",
  "TropicalSummerSignature": "/fonts/TropicalSummerSignature.ttf",
  "WeddingChardonnay": "/fonts/WeddingChardonnay.ttf",
  // KD463002WHITE_190x253
  "BebasNeue-Light": "/fonts/BebasNeue-Light.otf",
  "Berylium-BoldItalic": "/fonts/Berylium-BoldItalic.ttf",
  "Candara-Bold": "/fonts/Candara-Bold.ttf",
  "IndieFlower-KD463002": "/fonts/IndieFlower-KD463002.ttf",
  "LemonTuesday": "/fonts/LemonTuesday.otf",
  "Vollkorn-Regular": "/fonts/Vollkorn-Regular.ttf",
  "adelia": "/fonts/adelia.ttf",
  // KD46500_600_WHITE_BABY_330x333
  "HennyPenny-Regular": "/fonts/HennyPenny-Regular.ttf",
  "Bitter-Regular": "/fonts/Bitter-Regular.ttf",
  "Cardo-Bold": "/fonts/Cardo-Bold.ttf",
  // Dostarczone 2026-10-20
  "Asap-Medium": "/fonts/Asap-Medium.ttf",
  "Berylium-Bold": "/fonts/Berylium-Bold.ttf",
  "BodoniBT-BookItalic": "/fonts/BodoniBT-BookItalic.ttf",
  "BodoniBT-BoldItalic": "/fonts/BodoniBT-BoldItalic.ttf",
  "GoodUnicorn-Regular": "/fonts/GoodUnicornRegular-Rxev.ttf",
  "Gelyti": "/fonts/Gelyti.otf",
  // BasnieAndersen213x268
  "BookAntiqua": "/fonts/BookAntiqua.ttf",
  "Bajaderka-Regular": "/fonts/Bajaderka-Regular.otf",
  "DJBSandShoes": "/fonts/DJBSandShoesandaFezBold.ttf",
};